export default {"id":"icon-fingerprint"}